import React from 'react';
import { StarIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { testimonials } from '../data/testimonials';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
export function Testimonials() {
  const {
    t
  } = useLanguage();
  return <section id="testimonials" className="w-full bg-white py-20 sm:py-24" data-id="element-296" data-mp="3azjc3rzaca9k">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-297" data-mp="36ypqx6d899kd">
        <Reveal data-id="element-298" data-mp="36wwetbjuhx4z">
          <SectionHeading eyebrow={t('test.eyebrow')} title={t('test.title')} data-id="element-299" data-mp="31zw9j2utkyex" />
        </Reveal>

        <ul className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-300" data-mp="3228xbwn9e2zw">
          {testimonials.map((item, index) => <Reveal key={item.id} as="li" delay={index * 0.06} data-id="element-301" data-mp="2s2i6q61tk853" data-mpi={index}>
              <figure className="flex h-full flex-col rounded-xl border border-navy-900/10 bg-navy-50/60 p-6" data-id="element-302" data-mp="v9gbnrq5car9">
                <div className="flex items-center gap-0.5" aria-label="Rated 5 out of 5" data-id="element-303" data-mp="qalj3y2dn7ty">
                  {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-amber-600 text-amber-600" aria-hidden="true" data-id="element-304" data-mp="h4dfase4k07c" data-mpi={i} />)}
                </div>
                <blockquote className="mt-4 text-[15px] font-medium leading-relaxed text-navy-900" data-id="element-305" data-mp="c6ve5o6cmp9w">
                  “{t(item.quoteKey)}”
                </blockquote>
                <figcaption className="mt-auto flex items-center gap-3 pt-6" data-id="element-306" data-mp="zx7sbgs6ti8x">
                  <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full font-display text-sm font-bold text-white ${item.accent}`} aria-hidden="true" data-id="element-307" data-mp="14u7pf2727anw">
                    {item.initials}
                  </span>
                  <span data-id="element-308" data-mp="1iuih27g70ta4">
                    <span className="block text-sm font-bold text-navy-900" data-id="element-309" data-mp="1it7bq373ndgw">
                      {t(item.nameKey)}
                    </span>
                    <span className="block text-xs font-semibold text-brand-700" data-id="element-310" data-mp="1xiis4va4tii6">
                      {t(item.serviceKey)}
                    </span>
                  </span>
                </figcaption>
              </figure>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}